import { Box, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { addComponentToTaskTypeCols, getComponentDefaultValueForNewIntance } from "source/components/task/TaskTypeDialog/TaskTypeDialogFormDesigner/FormDesignerComponentPicker";
import { AppUtils } from "source/framework/appUtils";
import { SaveDataObj } from "source/framework/saveData";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { ConfirmationDialogResult, AppChartType, TaskDataRowDataType, TaskLockingType, TaskRepetitionType, TaskTypeClassHidden, TaskTypeClassWidthPrefix, TaskVisibility } from "ui/Scripts/source/models/enums";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { getSchemaFromTaskType, ISchemaParseResult, ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { createDateField, createUserNameField, ITaskTypeCol, modifyUserNameField, TaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import * as store from "../../../framework/customStore";
import * as taskService from "../../../models/services/taskService";
import { ISessionState } from "../../../models/session/sessionState";
import * as storeActions from "../../../models/store/storeActions";
import { ITaskTypeEditItem } from "../../../models/taskType/taskTypeEditItem";
import { CkEditorDialog } from "../../framework/Dialog/Dialog";
import { DialogButtons } from "../../framework/Dialog/DialogButtons";
import { DialogItemsNav } from "../../framework/Dialog/DialogItemsNav";
import { DialogTabs } from "../../framework/Dialog/DialogTabs";
import { TaskTypeDialogBasicInformation } from "./TaskTypeDialogBasicInformation";
import { TaskTypeDialogFormDesigner } from "./TaskTypeDialogFormDesigner/TaskTypeDialogFormDesigner";
import { TaskTypeDialogSchemaDialog } from "./TaskTypeDialogSchemaDialog";
import { TaskTypeDialogPreview } from "./TaskTypeDialogPreview";
import { getTaskFormDesignerComponentType, TaskFormDesignerComponentType } from "./TaskTypeDialogFormDesigner/FormDesignerComponentPicker/FormDesignerComponentPickerItem";
import { ILineColumnWidth } from "./TaskTypeDialogFormDesigner/FormDesignerComponentProperties/FormDesignerComponentPropertiesRow";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { TaskTypeDialogPreviewType } from "./TaskTypeDialogPreview/TaskTypeDialogPreviewWeb";
import { removeConfirmationWord } from "ui/Scripts/source/models/consts";
import { ITaskStateListItem } from "source/models/taskState/taskStateListItem";
import { ITaskPriorityListItem } from "source/models/taskPriority/taskPriorityListItem";
import { TaskTypeDialogTaskStateList } from "./TaskTypeDialogTaskStateList/TaskTypeDialogTaskStateList";
import { TTaskStateEditItemNewSave } from "source/models/taskState/taskStateEditItem";
import { TTaskPriorityEditItemNewSave } from "source/models/taskPriority/taskPriorityEditItem";
import { TaskTypeDialogTaskPriorityList } from "./TaskTypeDialogTaskPriorityList/TaskTypeDialogTaskPriorityList";
import { UnitBlocks } from "source/components/unit/UnitBlocks";
import { IRecordUnit, RecordUnit } from "ui/Scripts/source/models/unit/recordUnit";
import { getMobileWidthFromClass, getPrintWidthFromClass, getUpdatedClassForWidthSub, getUpdatedTaskDataRow, getWebWidthFromClass, ITaskTypeChartPropUpdate, ITaskTypeFieldPropUpdate, updateDefaultValueToDataRowCols, updateTaskTypeColPropUpdate, updateValueToDataRowCol } from "./FormDesignerTypes";
import { TaskTypeDialogChartDesigner } from "./TaskTypeDialogChartDesigner/TaskTypeDialogChartDesigner";
import { ITaskTypeChart, TaskTypeChart } from "ui/Scripts/source/models/task/taskTypeChart";
import { getChartNameForNewIntance, getChartTitleForNewIntance } from "./TaskTypeDialogChartDesigner/ChartDesignerChartPicker";

/* eslint-disable no-unused-vars */
export const enum TaskFormDesignerDialogMenuItem {
    General = "1",
    Builder = "2",
    PreviewWeb = "3",
    PreviewMobile = "4",
    PreviewPrint = "5",
    PreviewRowPrint = "6",
    ChartBuilder = "7",
}
/* eslint-enable no-unused-vars */

interface ITaskTypeDialogProps {
    id: string;
    sessionState: ISessionState;
    companyId: string;
    hasPrevious: boolean;
    hasNext: boolean;
    addToCompany: boolean;
    onPrevious: () => void;
    onNext: () => void;
    onSaved: () => void;
    onClose: () => void;
    onRemove: (ids: string[]) => Promise<ApiSuccess>;
    onRefreshList: () => Promise<void>;
}

export interface ITaskTypeDialogState {
    activeMenuItem: TaskFormDesignerDialogMenuItem;
    showSchemaDesignerDialog: boolean;
    code: string;
    comment: string;
    taskRepetitionType: TaskRepetitionType;
    taskLockingType: TaskLockingType;
    dataSchema: string;
    dataSchemaParseError: string;
    printOrientationLandscape: boolean;
    visibility: TaskVisibility;
    activeState: number;
    headerDataRow: ITaskDataRow;
    formDataRow: ITaskDataRow;
    chartTestDataRows: ITaskDataRow[];
    lineDataRow: ITaskDataRow;
    lineColumnWidths: ILineColumnWidth[];
    taskType: ITaskEditTypeItem;
    item: ITaskTypeEditItem;
    rowId: string;
    formSelectedField: string;
    headerSelectedField: string;
    selectedChartName: string;
    taskUnits: IdTitleNode[];
    taskStates: ITaskStateListItem[];
    taskPriorities: ITaskPriorityListItem[]
    taskTypeUnits: IRecordUnit[];
}

export const TaskTypeDialog = (props: ITaskTypeDialogProps) => {
    const orgStateHash = useRef<string>("");

    const [state, setState] = useState<ITaskTypeDialogState>({
        activeMenuItem: TaskFormDesignerDialogMenuItem.General,
        showSchemaDesignerDialog: false,
        item: null,
        headerDataRow: null,
        formDataRow: null,
        chartTestDataRows: [],
        lineDataRow: null,
        lineColumnWidths: [],
        taskType: null,
        code: "",
        comment: "",
        taskRepetitionType: TaskRepetitionType.NotRepeated,
        taskLockingType: TaskLockingType.NoLocking,
        dataSchema: "",
        dataSchemaParseError: "",
        printOrientationLandscape: false,
        visibility: TaskVisibility.PrivateAndPublic,
        activeState: 0,
        rowId: "",
        formSelectedField: "",
        headerSelectedField: "",
        selectedChartName: "",
        taskStates: [],
        taskPriorities: [],
        taskUnits: [],
        taskTypeUnits: [],
    });

    const getTaskTypeFromSchema = (dataSchema: string): ISchemaParseResult => {
        const result = TaskEditTypeItem.getTaskTypeFromSchema(dataSchema);
        if (!result.taskType) {
            return {
                taskType: state.taskType,
                headerDataRow: state.headerDataRow,
                formDataRow: state.formDataRow,
                chartTestDataRows: state.chartTestDataRows,
                lineDataRow: state.lineDataRow,
                error: result.error,
            };
        }
        return result;
    };

    const getSchemaFromState = () => getSchemaFromTaskType(state.taskType);

    const getSaveDataFromState = (props: ITaskTypeDialogProps, state: ITaskTypeDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("id", state.item?.id);
        result.append("companyId", props.companyId);
        result.append("rowId", state.rowId);
        result.append("code", state.code);
        result.append("comment", state.comment);
        result.append("taskRepetitionType", state.taskRepetitionType);
        result.append("taskLockingType", state.taskLockingType);
        result.append("dataSchema", state.dataSchema);
        result.append("printOrientationLandscape", state.printOrientationLandscape);
        result.append("visibility", state.visibility);
        result.append("activeState", state.activeState);
        const isNew = state.item?.isNew() || false;
        result.append("taskStates", isNew
            ? state.taskStates.map(i => {
                const result: TTaskStateEditItemNewSave = {
                    id: i.id,
                    code: i.code,
                    comment: i.comment,
                    color: i.color,
                    sortOrder: i.sortOrder,
                    editabilityType: i.editabilityType,
                    activeState: i.activeState
                };
                return result;
            })
            : null);
        result.append("taskPriorities", isNew
            ? state.taskPriorities.map(i => {
                const result: TTaskPriorityEditItemNewSave = {
                    id: i.id,
                    code: i.code,
                    comment: i.comment,
                    sortOrder: i.sortOrder,
                    activeState: i.activeState
                };
                return result;
            })
            : null);
        result.append("unitIds", isNew
            ? state.taskTypeUnits.map(i => {
                return i.unitId;
            })
            : null);
        return result;
    };

    const checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            if (!state.code) {
                store.customStore.dispatch(storeActions.showErrorMessage(Translations.NameMustBeDefined));
                return resolve(false);
            }
            return resolve(true);
        });
    };

    const getLineColumnWidths = (lineCols: ITaskTypeCol[], ignoreField: string = ""): ILineColumnWidth[] => lineCols?.filter(i => i.field !== ignoreField)?.map(item => ({
        field: item.field,
        webWidth: getWebWidthFromClass(item.class),
        mobileWidth: getMobileWidthFromClass(item.class),
        printWidth: getPrintWidthFromClass(item.class),
        locked: false
    }));

    const loadData = async (id: string, addToCompany: boolean) => {
        const result = await AppUtils.callService(() => taskService.getTaskTypeEdit(props.companyId, id, addToCompany), false);
        if (!result) return;
        const item = result.item;
        const parseResult = getTaskTypeFromSchema(item.dataSchema);
        const stateChange = {
            item,
            taskType: parseResult.taskType,
            headerDataRow: parseResult.headerDataRow,
            formDataRow: parseResult.formDataRow,
            chartTestDataRows: parseResult.chartTestDataRows,
            lineDataRow: parseResult.lineDataRow,
            lineColumnWidths: getLineColumnWidths(parseResult.taskType?.lineCols),
            code: item.code,
            comment: item.comment,
            taskRepetitionType: parseResult.taskType?.taskRepetitionType ?? item.taskRepetitionType,
            taskLockingType: item.taskLockingType,
            dataSchema: item.dataSchema,
            dataSchemaParseError: parseResult.error,
            printOrientationLandscape: item.printOrientationLandscape,
            visibility: item.visibility,
            activeState: item.activeState,
            rowId: item.rowId,
            taskStates: result.taskStates,
            taskPriorities: result.taskPriorities,
            taskUnits: result.units,
            taskTypeUnits: result.taskTypeUnits
        };
        setState((old) => ({
            ...old,
            ...stateChange
        }));
        orgStateHash.current = getSaveDataFromState(props, { ...state, ...stateChange }).hash;
    };

    const handleHeaderSchemaReorder = (startIndex: number, endIndex: number) => {
        const result = Array.from(state.taskType.headerCols);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                headerCols: result,
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType)
            };
        });
    };

    const handleFormSchemaReorder = (startIndex: number, endIndex: number) => {
        const result = Array.from(state.taskType.formCols);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                formCols: result,
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType)
            };
        });
    };

    const handleHeaderSchemaAddItem = (componentType: TaskFormDesignerComponentType, index: number, copyTaskTypeCol: ITaskTypeCol = null) => {
        setState((old) => {
            const result = addComponentToTaskTypeCols(old.taskType.headerCols, componentType, index, copyTaskTypeCol);
            const dataRowCol = new TaskDataRowCol();
            dataRowCol.field = result.field;
            dataRowCol.valueStr = getComponentDefaultValueForNewIntance(componentType);
            const newTaskType = {
                ...old.taskType,
                headerCols: [...result.typeCols],
            };
            const headerDataRow = new TaskDataRow(old.headerDataRow);
            headerDataRow.cols = headerDataRow.cols.filter(i => i.field !== result.field).concat([dataRowCol]);
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                headerDataRow,
                headerSelectedField: result.field,
                formSelectedField: ""
            };
        });
    };

    const handleFormSchemaAddItem = (componentType: TaskFormDesignerComponentType, index: number, copyTaskTypeCol: ITaskTypeCol = null) => {
        setState((old) => {
            const result = addComponentToTaskTypeCols(old.taskType.formCols, componentType, index, copyTaskTypeCol);
            const dataRowCol = new TaskDataRowCol();
            dataRowCol.field = result.field;
            dataRowCol.valueStr = getComponentDefaultValueForNewIntance(componentType);
            const newTaskType = {
                ...old.taskType,
                formCols: [...result.typeCols],
            };
            const formDataRow = new TaskDataRow(state.formDataRow);
            formDataRow.cols = formDataRow.cols.filter(col => col.field !== result.field).concat([dataRowCol]);
            const chartTestDataRows = old.chartTestDataRows.map(i => {
                const chartDataRowCol = TaskDataRowCol.getTestValueTaskDataRowCol(result.typeCol);
                chartDataRowCol.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(result.typeCol, chartDataRowCol.valueStr, chartDataRowCol.valueNbr);
                const chartTestDataRow = new TaskDataRow(i);
                chartTestDataRow.cols = chartTestDataRow.cols.filter(col => col.field !== result.field).concat([chartDataRowCol]);
                return chartTestDataRow;
            });
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                formDataRow,
                chartTestDataRows,
                formSelectedField: result.field,
                headerSelectedField: ""
            };
        });
    };

    const handleRowSchemaReorder = (startIndex: number, endIndex: number) => {
        const result = Array.from(state.taskType.lineCols);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                lineCols: result
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType)
            };
        });
    };

    const handleHeaderItemClick = (headerSelectedField: string) => {
        setState((old) => ({
            ...old,
            headerSelectedField,
            formSelectedField: headerSelectedField
                ? ""
                : state.formSelectedField
        }));
    };

    const handleFormItemClick = (formSelectedField: string) => {
        setState((old) => ({
            ...old,
            formSelectedField,
            headerSelectedField: formSelectedField
                ? ""
                : state.headerSelectedField
        }));
    };
    
    useEffect(() => {
        if (!props.id) return;
        loadData(props.id, props.addToCompany);
    }, [props.companyId, props.id, props.addToCompany]);

    const handleChange = (event: { target: any; }) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "code") {
            setState((old) => ({ ...old, code: value }));
        } else if (name === "name") {
            setState((old) => ({ ...old, name: value }));
        } else if (name === "comment") {
            setState((old) => ({ ...old, comment: value }));
        }
    };

    const saveToDb = async (): Promise<SaveSuccess> => {
        if (!await AppUtils.validate(checkErrors)) return null;
        const saveData = getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => taskService.saveTaskTypeEdit(saveData.obj));
        if (!result) return null;
        //Update state and hash
        const stateChange = { id: result.id, rowId: result.rowId };
        orgStateHash.current = getSaveDataFromState(props, { ...state, ...stateChange }).hash;
        setState((old) => ({
            ...old,
            ...stateChange
        }));
        return result;
    };

    const handleSave = async (closeDialog: boolean) => {
        const result = await saveToDb();
        if (!result) return;
        if (!closeDialog) {
            loadData(result.id, false);
            props.onSaved();
            return;
        }
        props.onClose();
    };

    const handleRemove = async () => {
        if (state.item?.isNew()) return;
        if (await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToRemoveFormParameter, state.item.code), false, removeConfirmationWord) === ConfirmationDialogResult.Yes) {
            // Call server
            const result = await props.onRemove([state.item?.id]);
            if (!result) return;
            props.onClose();
        }
    };

    const handleCancel = async () => {
        const cancelResult = await AppUtils.cancel(getSaveDataFromState(props, state).hash, orgStateHash.current, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            handleSave(true);
        } else {
            props.onClose();
        }
    };

    const canMoveOut = async (): Promise<boolean> => {
        return await AppUtils.canMoveOut(getSaveDataFromState(props, state).hash, orgStateHash.current,
            async () => !!(await saveToDb()),
            props.onRefreshList,
            (newStateHash) => { orgStateHash.current = newStateHash; });
    };

    const handlePrevious = async () => {
        if (!await canMoveOut()) return;
        setState((old) => ({
            ...old,
            formSelectedField: null,
            headerSelectedField: null,
            selectedChartName: null
        }));
        props.onPrevious();
    };

    const handleNext = async () => {
        if (!await canMoveOut()) return;
        setState((old) => ({
            ...old,
            formSelectedField: null,
            headerSelectedField: null,
            selectedChartName: null
        }));
        props.onNext();
    };

    const handleHeaderTaskTypePropUpdate = (values: ITaskTypeFieldPropUpdate[]) => {
        //TypeCol update
        const updated = updateTaskTypeColPropUpdate(state.taskType.headerCols, values);
        const taskType = {
            ...state.taskType,
            headerCols: updated.taskTypeCols
        };
        //Default value update
        const headerDataRow = new TaskDataRow(state.headerDataRow);
        if (updated.typeCol) {
            for (const value of values) {
                if (value.name === "defaultStr" || value.name === "defaultNbr") {
                    updateDefaultValueToDataRowCols(headerDataRow, updated.typeCol, value.field);
                }
            }
        }
        setState((old) => ({
            ...old,
            taskType,
            headerDataRow,
            dataSchema: getSchemaFromTaskType(taskType)
        }));
    };

    const handleFormTaskTypePropUpdate = (values: ITaskTypeFieldPropUpdate[]) => {
        //TypeCol update
        const updated = updateTaskTypeColPropUpdate(state.taskType.formCols, values);
        const taskType = {
            ...state.taskType,
            formCols: updated.taskTypeCols
        };
        //Default value update for data row
        const formDataRow = new TaskDataRow(state.formDataRow);
        if (updated.typeCol) {
            for (const value of values) {
                if (value.name === "defaultStr" || value.name === "defaultNbr") {
                    updateDefaultValueToDataRowCols(formDataRow, updated.typeCol, value.field);
                }
            }
        }
        setState((old) => ({
            ...old,
            taskType,
            formDataRow,
            dataSchema: getSchemaFromTaskType(taskType)
        }));
    };
    
    const handleHeaderTaskDataRowValueUpdate = (field: string, name: string, value: string | number | boolean) => {
        const headerDataRow = new TaskDataRow(state.headerDataRow);
        updateValueToDataRowCol(headerDataRow, field, name, value);
        setState((old) => ({
            ...old,
            headerDataRow
        }));
    };
    
    const handleFormTaskDataRowValueUpdate = (field: string, name: string, value: string | number | boolean) => {
        if (!state.formDataRow) return;
        const formDataRow = new TaskDataRow(state.formDataRow);
        updateValueToDataRowCol(formDataRow, field, name, value);
        setState((old) => ({
            ...old,
            formDataRow
        }));
    };

    const handleHeaderRemoveComponent = async (field: string) => {
        if (await AppUtils.showConfirmationDialog(Translations.FormRemoveFieldConfirmation, false) === ConfirmationDialogResult.No) {
            return;
        }
        const headerDataRow = new TaskDataRow(state.headerDataRow);
        headerDataRow.cols = headerDataRow.cols.filter(i => i.field !== field);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                headerCols: old.taskType?.headerCols?.filter(item => item.field !== field)
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                headerDataRow
            };
        });
    };

    const handleHeaderCopyComponent = async (id: string) => {
        const taskTypeCol = state.taskType.headerCols.find(i => i.field === id);
        if (!taskTypeCol) return;
        const designerComponentType = getTaskFormDesignerComponentType(taskTypeCol);
        handleHeaderSchemaAddItem(designerComponentType, state.taskType.headerCols.findIndex(i => i.field === id) + 1, taskTypeCol);
    };

    const handleFormRemoveComponent = async (field: string) => {
        if (await AppUtils.showConfirmationDialog(Translations.FormRemoveFieldConfirmation, false) === ConfirmationDialogResult.No) {
            return;
        }
        const formDataRow = new TaskDataRow(state.formDataRow);
        formDataRow.cols = formDataRow.cols.filter(i => i.field !== field);
        const chartTestDataRows = state.chartTestDataRows.map(i => {
            const chartTestDataRow = new TaskDataRow(i);
            chartTestDataRow.cols = chartTestDataRow.cols.filter(i => i.field !== field);
            return chartTestDataRow;
        });
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                formCols: old.taskType?.formCols?.filter(item => item.field !== field),
                lineCols: old.taskType?.lineCols?.filter(item => item.field !== field),
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                formDataRow,
                chartTestDataRows
            };
        });
    };

    const handleFormCopyComponent = async (id: string) => {
        const taskTypeCol = state.taskType.formCols.find(i => i.field === id);
        if (!taskTypeCol) return;
        const designerComponentType = getTaskFormDesignerComponentType(taskTypeCol);
        handleFormSchemaAddItem(designerComponentType, state.taskType.formCols.findIndex(i => i.field === id) + 1, taskTypeCol);
    };

    const handleLineTaskTypePropUpdate = (values: ITaskTypeFieldPropUpdate[]) => {
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                lineCols: old.taskType?.lineCols?.map((item) => {
                    const value = values.find(i => i.field === item.field);
                    if (value) {
                        const res = { ...item };
                        res[value.name] = value.value;
                        return res;
                    }
                    return { ...item };
                }),
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType)
            };
        });
    };

    //Do not decrease hidden or locked columns widths
    const decreaseLineWidthsSub = (widths: ILineColumnWidth[], widthField: "webWidth" | "mobileWidth" | "printWidth") => {
        const nonZeroWidths = widths.filter(i => i[widthField]);
        if (!nonZeroWidths.length || !nonZeroWidths.filter(i => !i.locked).length) return;
        while (nonZeroWidths.reduce((accumulator, item) => accumulator + item[widthField], 0) > 12) {
            nonZeroWidths.filter(i => !i.locked).sort((a, b) => b[widthField] - a[widthField])[0][widthField] -= 1;
        }
    };

    //Do not increase hidden or locked columns widths
    const increaseLineWidthsSub = (widths: ILineColumnWidth[], widthField: "webWidth" | "mobileWidth" | "printWidth") => {
        const nonZeroWidths = widths.filter(i => i[widthField]);
        if (!nonZeroWidths.length || !nonZeroWidths.filter(i => !i.locked).length) return;
        while (nonZeroWidths.reduce((accumulator, item) => accumulator + item[widthField], 0) < 12) {
            nonZeroWidths.filter(i => !i.locked).sort((a, b) => a[widthField] - b[widthField])[0][widthField] += 1;
        }
    };

    const decreaseLineWidths = (widths: ILineColumnWidth[]) => {
        decreaseLineWidthsSub(widths, "webWidth");
        decreaseLineWidthsSub(widths, "mobileWidth");
        decreaseLineWidthsSub(widths, "printWidth");
    };

    const increaseLineWidths = (widths: ILineColumnWidth[]) => {
        increaseLineWidthsSub(widths, "webWidth");
        increaseLineWidthsSub(widths, "mobileWidth");
        increaseLineWidthsSub(widths, "printWidth");
    };

    const updateAllWidthsToClass = (classes: string, field: string, widths: ILineColumnWidth[]) => {
        //console.log("updateAllWidthsToClass S", `'${classes}'`, field, widths);
        const result = getUpdatedClassForWidthSub(
            getUpdatedClassForWidthSub(
                getUpdatedClassForWidthSub(
                    classes,
                    [TaskTypeClassWidthPrefix.Web, TaskTypeClassWidthPrefix.Web2, TaskTypeClassWidthPrefix.Mobile, TaskTypeClassWidthPrefix.Print],
                    [],
                    TaskTypeClassWidthPrefix.Web,
                    TaskTypeClassHidden.Web,
                    widths.find((x) => x.field === field).webWidth
                ),
                [],
                [],
                TaskTypeClassWidthPrefix.Mobile,
                TaskTypeClassHidden.Mobile,
                widths.find((x) => x.field === field).mobileWidth
            ),
            [],
            [],
            TaskTypeClassWidthPrefix.Print,
            TaskTypeClassHidden.Print,
            widths.find((x) => x.field === field).printWidth
        );
        //console.log("updateAllWidthsToClass E", `'${result}'`);
        return result;
    };

    const handleRemoveFieldFromLine = async (field: string) => {
        if ((await AppUtils.showConfirmationDialog(
            Translations.FormRemoveColumnFromRowConfirmation,
            false
        )) === ConfirmationDialogResult.No) {
            return;
        }
        const lineColumnWidths = state.lineColumnWidths.filter((i) => i.field !== field);
        //console.log("lineColumnWidths 1", lineColumnWidths.map(i => ({ field: i.field, webWidth: i.webWidth, mobileWidth: i.mobileWidth, printWidth: i.printWidth })));
        increaseLineWidths(lineColumnWidths);
        //console.log("lineColumnWidths 2", lineColumnWidths);
        const lineDataRow = new TaskDataRow(state.lineDataRow);
        lineDataRow.cols = lineDataRow.cols.filter(i => i.field !== field);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                lineCols: old.taskType?.lineCols
                    ?.filter((item) => item.field !== field)
                    .map((item) => ({
                        ...item,
                        class: updateAllWidthsToClass(item.class, item.field, lineColumnWidths),
                    })),
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                lineDataRow,
                lineColumnWidths,
                taskRepetitionType: lineColumnWidths.length ? TaskRepetitionType.Repeated : TaskRepetitionType.NotRepeated
            };
        });
    };

    const handleAddFieldToLine = async (id: string) => {
        const newWidth = Math.max(Math.floor(12 / (state.taskType?.lineCols?.length + 1)), 1);
        const lineColumnWidths = state.lineColumnWidths.slice(0);
        lineColumnWidths.push({
            field: id,
            webWidth: newWidth,
            mobileWidth: newWidth,
            printWidth: newWidth,
            locked: false
        });
        //increaseLineWidths(widths);
        decreaseLineWidths(lineColumnWidths);
        //Do not duplicate all form type fields to line, only required
        const formTypeCol = state.taskType?.formCols?.find((item) => item.field === id);
        const newLineCol = new TaskTypeCol();
        newLineCol.field = id;
        newLineCol.title = formTypeCol
            ? formTypeCol.title
            : id.equalIgnoreCase(createUserNameField)
                ? Translations.FormCreateUser
                : id.equalIgnoreCase(createDateField)
                    ? Translations.FormCreateDate
                    : id.equalIgnoreCase(modifyUserNameField)
                        ? Translations.FormModifyUser
                        : Translations.FormModifyDate;
        newLineCol.dataType = formTypeCol
            ? formTypeCol.dataType
            : (id.equalIgnoreCase(createUserNameField) || id.equalIgnoreCase(modifyUserNameField)
                ? TaskDataRowDataType.String
                : TaskDataRowDataType.Date);
        newLineCol.class = updateAllWidthsToClass("", id, lineColumnWidths);
        newLineCol.defaultSortField = formTypeCol?.defaultSortField ?? false;
        newLineCol.defaultSortOrderAsc = formTypeCol?.defaultSortOrderAsc ?? false;
        //Update state
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                lineCols: [
                    ...old.taskType?.lineCols.map((item) => ({
                        ...item,
                        class: updateAllWidthsToClass(item.class, item.field, lineColumnWidths)
                    })),
                    newLineCol
                ],
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                lineColumnWidths,
                taskRepetitionType: lineColumnWidths.length ? TaskRepetitionType.Repeated : TaskRepetitionType.NotRepeated
            };
        });
    };

    const handleChangeLineColumnWidth = (id: string, classes: string) => {
        const lineColumnWidths = state.lineColumnWidths.filter((i) => i.field !== id);
        lineColumnWidths.push({
            field: id,
            webWidth: getWebWidthFromClass(classes),
            mobileWidth: getMobileWidthFromClass(classes),
            printWidth: getPrintWidthFromClass(classes),
            locked: true
        });
        //console.log("handleChangeLineColumnWidth S", lineColumnWidths.map(i => ({ field: i.field, webWidth: i.webWidth, mobileWidth: i.mobileWidth, printWidth: i.printWidth })));
        increaseLineWidths(lineColumnWidths);
        //console.log("handleChangeLineColumnWidth I", lineColumnWidths.map(i => ({ field: i.field, webWidth: i.webWidth, mobileWidth: i.mobileWidth, printWidth: i.printWidth })));
        decreaseLineWidths(lineColumnWidths);
        //console.log("handleChangeLineColumnWidth D", lineColumnWidths);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                lineCols: old.taskType?.lineCols
                    .map((item) => ({
                        ...item,
                        class: updateAllWidthsToClass(item.class, item.field, lineColumnWidths),
                    })),
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                lineColumnWidths
            };
        });
    };
    
    const handleOpenSchemaDialog = () => {
        setState((old) => ({
            ...old,
            dataSchema: getSchemaFromState(),
            showSchemaDesignerDialog: true,
        }));
    };

    const handleSaveSchemaDialog = (value: string) => {
        const parseResult = getTaskTypeFromSchema(value);
        setState((old) => ({
            ...old,
            taskType: parseResult.taskType,
            headerDataRow: parseResult.headerDataRow,
            formDataRow: parseResult.formDataRow,
            chartTestDataRows: parseResult.chartTestDataRows,
            lineDataRow: parseResult.lineDataRow,
            lineColumnWidths: getLineColumnWidths(parseResult.taskType?.lineCols),
            dataSchemaParseError: parseResult.error,
            taskRepetitionType: parseResult.taskType?.taskRepetitionType ?? state.taskRepetitionType,
            dataSchema: value,
            showSchemaDesignerDialog: false,
        }));
    };

    const handleCloseSchemaDialog = () => {
        setState((old) => ({ ...old, showSchemaDesignerDialog: false }));
    };

    const isNew = state.item?.isNew();

    // #region TaskTypeUnits
    const addUnits = async (units: IIdTitleNode[]): Promise<ApiSuccess> => {
        const addUnits = units.filter(i => !state.taskTypeUnits.find(j => j.unitId === i.id));
        if (!addUnits || addUnits.length < 1) return null;
        if (!isNew) {
            const result = await AppUtils.callService(() => taskService.taskTypeAddUnits(props.companyId, state.item.id, addUnits.map(i => i.id)), true);
            if (!result) return null;
        }
        const taskTypeUnits = state.taskTypeUnits.slice(0);
        for (const unit of addUnits) {
            const recordUnit = new RecordUnit();
            recordUnit.id = Base.getGuid();
            recordUnit.unitId = unit.id;
            recordUnit.title = unit.title;
            taskTypeUnits.push(recordUnit);
        }
        setState((old) => ({ ...old, taskTypeUnits }));
        return new ApiSuccess();
    };

    const handleAddUnit = (unit: IIdTitleNode): Promise<ApiSuccess> => {
        if (!unit) return;
        return addUnits([unit]);
    };

    const handleRemoveUnits = async (unitIds: string[]): Promise<ApiSuccess> => {
        if (!unitIds || unitIds.length < 1) return;
        if (!isNew) {
            const result = await AppUtils.callService(() => taskService.taskTypeRemoveUnits(props.companyId, state.item.id, unitIds));
            if (!result) return null;
        }
        setState((old) => ({ ...old, taskTypeUnits: old.taskTypeUnits.filter(i => unitIds.indexOf(i.unitId) < 0) }));
        return new ApiSuccess();
    };
    // #endregion TaskTypeUnits

    // #region Preview
    const handleUpdateHeaderDataRowCols = (taskDataRowCols: ITaskDataRowCol[]) => {
        setState((old) => ({
            ...old,
            headerDataRow: getUpdatedTaskDataRow(state.headerDataRow, taskDataRowCols)
        }));
    };

    const handleUpdatFormDataRowCols = (taskDataRowCols: ITaskDataRowCol[]) => {
        const formDataRow = getUpdatedTaskDataRow(state.formDataRow, taskDataRowCols);
        setState((old) => ({
            ...old,
            formDataRow,
            lineDataRow: getUpdatedTaskDataRow(state.lineDataRow, taskDataRowCols),
        }));
    };
    // #endregion Preview

    // #region Charts
    const addChartToTaskTypeCols = (taskTypeCharts: ITaskTypeChart[], taskChartType: AppChartType, index: number, copyTaskTypeChart: ITaskTypeChart = null): { taskTypeCharts: ITaskTypeChart[], name: string } => {
        const result = Array.from(taskTypeCharts).map(item => item);
        const item = new TaskTypeChart();
        item.name = getChartNameForNewIntance(taskTypeCharts.map(item => item.name), taskChartType);
        item.title = getChartTitleForNewIntance(taskTypeCharts.map(item => item.title), taskChartType);
        item.taskChartType = taskChartType;
        if (copyTaskTypeChart) {
            item.groupingFields = copyTaskTypeChart.groupingFields.slice(0);
            item.valueFields = copyTaskTypeChart.valueFields.slice(0);
        }
        result.splice(index, 0, item);
        return {
            taskTypeCharts: result,
            name: item.name
        };
    };

    const handleChartSchemaAddItem = (taskChartType: AppChartType, index: number, copyTaskTypeChart: ITaskTypeChart = null) => {
        setState((old) => {
            const result = addChartToTaskTypeCols(old.taskType.charts, taskChartType, index, copyTaskTypeChart);
            const newTaskType = {
                ...old.taskType,
                charts: [...result.taskTypeCharts],
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
                selectedChartName: result.name
            };
        });
    };

    const handleChartSchemaReorder = (name: string, endIndex: number) => {
        const result = Array.from(state.taskType.charts);
        const startIndex = result.findIndex(i => i.name === name);
        if (startIndex < 0) return;
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                charts: result
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType)
            };
        });
    };

    const handleRemoveChart = async (name: string) => {
        if (await AppUtils.showConfirmationDialog(Translations.ChartRemoveFieldConfirmation, false) === ConfirmationDialogResult.No) {
            return;
        }
        setState((old) => {
            const newTaskType = {
                ...old.taskType,
                charts: old.taskType?.charts?.filter(item => item.name !== name),
            };
            return {
                ...old,
                taskType: newTaskType,
                dataSchema: getSchemaFromTaskType(newTaskType),
            };
        });
    };

    const handleCopyChart = async (name: string) => {
        const chart = state.taskType.charts.find(i => i.name === name);
        if (!chart) return;
        handleChartSchemaAddItem(chart.taskChartType, state.taskType.charts.findIndex(i => i.name === name) + 1, chart);
    };

    const updateTaskTypeChartProp = (values: ITaskTypeChartPropUpdate[]) => {
        //console.log("updateTaskTypeChartProp", values);
        const result = state.taskType.charts.map((item) => {
            const chartPropValues = values.filter(i => i.name === item.name);
            //console.log("chartPropValues", chartPropValues);
            if (chartPropValues.length) {
                //console.log("item", { ...item });
                const res = { ...item };
                for (const value of chartPropValues) {
                    res[value.prop] = value.value;
                }
                //console.log("res", res);
                return res;
            }
            return item;
        });
        return {
            charts: result
        };
    };

    const handleChartPropUpdate = (values: ITaskTypeChartPropUpdate[]) => {
        const updated = updateTaskTypeChartProp(values);
        const taskType = {
            ...state.taskType,
            charts: updated.charts
        };
        setState((old) => ({
            ...old,
            taskType,
            dataSchema: getSchemaFromTaskType(taskType)
        }));
    };

    const handleChartClick = (selectedChartName: string) => {
        setState((old) => ({
            ...old,
            selectedChartName
        }));
    };

    const handleChartTestDataRowsChange = (chartTestDataRows: ITaskDataRow[]) => {
        setState((old) => ({
            ...old,
            chartTestDataRows
        }));
    };
    // #endregion Charts

    if (!state.taskType) return null;

    return <CkEditorDialog
        id="taskTypeDialog"
        maxWidth="xl"
        maxHeight="100%"
        title={isNew ? Translations.AddTaskType : (Translations.TaskType + ": " + state.item?.code)}
        dialogTabs={
            <DialogTabs
                activeTabId={state.activeMenuItem}
                tabs={[
                    { id: TaskFormDesignerDialogMenuItem.General, title: Translations.BasicInformation },
                    { id: TaskFormDesignerDialogMenuItem.Builder, title: Translations.FormBuilder },
                    { id: TaskFormDesignerDialogMenuItem.PreviewWeb, title: Translations.PreviewWeb },
                    { id: TaskFormDesignerDialogMenuItem.PreviewMobile, title: Translations.PreviewMobile },
                    { id: TaskFormDesignerDialogMenuItem.PreviewPrint, title: Translations.PreviewPrint },
                    { id: TaskFormDesignerDialogMenuItem.PreviewRowPrint, title: Translations.PreviewRowPrint, hidden: state.taskRepetitionType !== TaskRepetitionType.Repeated },
                    { id: TaskFormDesignerDialogMenuItem.ChartBuilder, title: Translations.ChartBuilder, hidden: state.taskRepetitionType !== TaskRepetitionType.Repeated },
                ]}
                onChangeTab={(activeMenuItem: TaskFormDesignerDialogMenuItem) => setState((old) => ({ ...old, activeMenuItem }))}
            />
        }
        body={<Box display="flex" flexDirection="column" height="100%">
            {state.activeMenuItem === TaskFormDesignerDialogMenuItem.General &&
                <Grid container height="100%">
                    <Grid item sm={8} height="100%">
                        <DialogSectionCard headerTitle={Translations.BasicInformation}>
                            <Grid sx={{
                                overflowY: "auto",
                                overflowX: "hidden",
                                height: "100%",
                                flexGrow: 1
                            }}>
                                <TaskTypeDialogBasicInformation
                                    code={state.code}
                                    comment={state.comment}
                                    taskLockingType={state.taskLockingType}
                                    printOrientationLandscape={state.printOrientationLandscape}
                                    visibility={state.visibility}
                                    activeState={state.activeState}
                                    item={state.item}
                                    isNew={isNew}
                                    onHandleChange={handleChange}
                                    onUpdateTaskLockingType={(taskLockingType) => setState((old) => ({ ...old, taskLockingType }))}
                                    onUpdateVisibility={(visibility) => setState((old) => ({ ...old, visibility }))}
                                    onUpdatePrintOrientationLandscape={(printOrientationLandscape) => setState((old) => ({ ...old, printOrientationLandscape }))}
                                    onUpdateActiveState={(activeState) => setState((old) => ({ ...old, activeState }))}
                                />
                            </Grid>
                        </DialogSectionCard>
                    </Grid>
                    <Grid item sm={4} sx={{ paddingLeft: "16px" }} height="100%">
                        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <Box sx={{ flexGrow: 5, height: 0, paddingBottom: "16px" }}>
                                <TaskTypeDialogTaskStateList
                                    companyId={props.companyId}
                                    taskTypeId={state.item?.id}
                                    taskStates={state.taskStates}
                                    onChange={(taskStates: ITaskStateListItem[]) => setState((old) => ({ ...old, taskStates }))}
                                />
                            </Box>
                            <Box sx={{ flexGrow: 5, height: 0, paddingBottom: props.companyId ? "16px" : undefined }}>
                                <TaskTypeDialogTaskPriorityList
                                    companyId={props.companyId}
                                    taskTypeId={state.item?.id}
                                    taskPriorities={state.taskPriorities}
                                    onChange={(taskPriorities: ITaskPriorityListItem[]) => setState((old) => ({ ...old, taskPriorities }))}
                                />
                            </Box>
                            {!!props.companyId &&
                                <Box sx={{ flexGrow: 3, height: 0 }}>
                                    <UnitBlocks
                                        title={Translations.TaskTypeUnits}
                                        noUnitsMessage={Translations.TaskTypeUsedInAllUnits}
                                        showInPanel={true}
                                        height="100%"
                                        unitTree={state.taskUnits}
                                        units={state.taskTypeUnits.map(i => IdTitleNode.createIdTitleNode(i.unitId, i.title, []))}
                                        onAddUnit={handleAddUnit}
                                        onRemoveUnits={handleRemoveUnits}
                                    />
                                </Box>
                            }
                        </Box>
                    </Grid>
                </Grid>
            }
            {state.activeMenuItem === TaskFormDesignerDialogMenuItem.Builder &&
                <TaskTypeDialogFormDesigner
                    companyId={props.companyId}
                    taskRepetitionType={state.taskRepetitionType}
                    taskType={state.taskType}
                    formDataRow={state.formDataRow}
                    lineDataRow={state.lineDataRow}
                    lineColumnWidths={state.lineColumnWidths}
                    headerTypeCol={state.taskType?.headerCols?.find(item => item?.field === state.headerSelectedField)}
                    formTypeCol={state.taskType?.formCols?.find(item => item?.field === state.formSelectedField)}
                    lineTypeCol={state.taskType?.lineCols?.find(item => item?.field === state.formSelectedField)}
                    sessionState={props.sessionState}
                    onHeaderSchemaReorder={handleHeaderSchemaReorder}
                    onHeaderSchemaAddItem={handleHeaderSchemaAddItem}
                    onFormSchemaReorder={handleFormSchemaReorder}
                    onFormSchemaAddItem={handleFormSchemaAddItem}
                    onRowSchemaReorder={handleRowSchemaReorder}
                    onHeaderItemClick={handleHeaderItemClick}
                    onFormItemClick={handleFormItemClick}
                    onTaskTypeHeaderPropUpdate={handleHeaderTaskTypePropUpdate}
                    onTaskTypeFormPropUpdate={handleFormTaskTypePropUpdate}
                    onTaskTypeLinePropUpdate={handleLineTaskTypePropUpdate}
                    onHeaderTaskDataRowValueUpdate={handleHeaderTaskDataRowValueUpdate}
                    onFormTaskDataRowValueUpdate={handleFormTaskDataRowValueUpdate}
                    onHeaderRemoveComponent={handleHeaderRemoveComponent}
                    onHeaderCopyComponent={handleHeaderCopyComponent}
                    onFormRemoveComponent={handleFormRemoveComponent}
                    onFormCopyComponent={handleFormCopyComponent}
                    onAddFieldToLine={handleAddFieldToLine}
                    onRemoveFieldFromLine={handleRemoveFieldFromLine}
                    onChangeLineColumnWidth={handleChangeLineColumnWidth}
                    onViewSchema={handleOpenSchemaDialog}
                />
            }
            {(state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewWeb || state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewMobile || state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewPrint || state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewRowPrint) &&
                <TaskTypeDialogPreview
                    previewType={state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewWeb
                        ? TaskTypeDialogPreviewType.Web
                        : (state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewMobile
                            ? TaskTypeDialogPreviewType.Mobile
                            : (state.activeMenuItem === TaskFormDesignerDialogMenuItem.PreviewPrint
                                ? TaskTypeDialogPreviewType.Print
                                : TaskTypeDialogPreviewType.PrintRow
                            )
                        )}
                    taskRepetitionType={state.taskRepetitionType}
                    dataSchema={state.dataSchema}
                    headerDataRow={state.headerDataRow}
                    formDataRow={state.formDataRow}
                    lineDataRow={state.lineDataRow}
                    //Print preview
                    companyId={props.companyId}
                    code={state.code}
                    printOrientationLandscape={state.printOrientationLandscape}
                    //Properties Panel
                    headerTypeCol={state.taskType?.headerCols?.find(item => item?.field === state.headerSelectedField)}
                    formTypeCol={state.taskType?.formCols?.find(item => item?.field === state.formSelectedField)}
                    lineTypeCol={state.taskType?.lineCols?.find(item => item?.field === state.formSelectedField)}
                    lineColumnWidths={state.lineColumnWidths}
                    onHeaderItemClick={handleHeaderItemClick}
                    onFormItemClick={handleFormItemClick}
                    onTaskTypeHeaderPropUpdate={handleHeaderTaskTypePropUpdate}
                    onTaskTypeFormPropUpdate={handleFormTaskTypePropUpdate}
                    onUpdateHeaderDataRowCols={handleUpdateHeaderDataRowCols}
                    onUpdateFormDataRowCols={handleUpdatFormDataRowCols}
                    onChangeLineColumnWidth={handleChangeLineColumnWidth}
                />
            }
            {state.activeMenuItem === TaskFormDesignerDialogMenuItem.ChartBuilder && (
                <TaskTypeDialogChartDesigner
                    sessionState={props.sessionState}
                    taskType={state.taskType}
                    selectedTaskTypeChart={state.taskType?.charts?.find(item => item.name === state.selectedChartName)}
                    chartTestDataRows={state.chartTestDataRows}
                    onChartSchemaAddItem={handleChartSchemaAddItem}
                    onChartSchemaMoveItem={handleChartSchemaReorder}
                    onChartClick={handleChartClick}
                    onRemoveChart={handleRemoveChart}
                    onCopyChart={handleCopyChart}
                    onChartPropUpdate={handleChartPropUpdate}
                    onChartTestDataRowsChange={handleChartTestDataRowsChange}
                />
            )}
            {state.showSchemaDesignerDialog && (
                <TaskTypeDialogSchemaDialog
                    dataSchema={state.dataSchema}
                    onSave={handleSaveSchemaDialog}
                    onClose={handleCloseSchemaDialog}
                />
            )}
        </Box>
        }
        actions={
            <Box display="flex" justifyContent="space-between" width="100%">
                <DialogItemsNav
                    modifyUser={!isNew ? state.item?.modifyUser : null}
                    hasPrevious={props.hasPrevious}
                    hasNext={props.hasNext}
                    onPrevious={handlePrevious}
                    onNext={handleNext}
                />
                <DialogButtons
                    isNew={isNew}
                    onCancel={handleCancel}
                    onRemove={!isNew ? handleRemove : null}
                    onSave={() => handleSave(false)}
                />
            </Box>
        }
        onClose={handleCancel}
    />;
};
